var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.loadingDownloadData,"absolute":"","opacity":"0.1"}},[_c('center',[_c('img',{attrs:{"width":"100","src":require('@/assets/img/magnifier-zoom-search.gif')}}),_c('div',{staticClass:"text-center",staticStyle:{"color":"#077893"}},[_c('h3',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t("overlay.load")))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }